export default {
    "logoLink":"https://www.atfx.com/pt",
    "FCA_License_No":"FCA Licença N.º",
    "headTtitle":"Abra uma Conta Real de Trading com Forex e CFD | ATFX UK",
    "topFixedBanner": "A apostas de spread e os CFDs são instrumentos complexos que acarretam um elevado risco de perda rápida de dinheiro, devido à alavancagem. A grande maioria das contas de clientes de retalho perdem dinheiro aquando da negociação de CFDs. Deverá considerar se pode assumir o elevado risco de perder o seu dinheiro.",//修改该参数请在/static/lang.js也需修改
    "topFixedBannerShort": "59.38% das contas de investidores retalhistas perdem dinheiro, aquando do trading de CFDs com este prestador.",//修改该参数请在/static/lang.js也需修改
    "headDescription":"Abra uma Conta ATFX Real de Trading com Forex e CFD junto de uma correctora regulada UK FCA. Baixo spread, alavancagem de 1:200, plataforma MT4, suporte ao cliente 24/5. Registe uma conta agora!",
    "policyBarClose": 'A Empresa decidiu cessar a prestação de serviços a clientes de retalho, com efeito imediato. Portanto, não podemos aceitar quaisquer inscrições.<br />Os serviços para clientes profissionais não serão afetados. Para aplicações profissionais, entre em contato com <a href="mailto:cs.uk@atfx.com">cs.uk@atfx.com</a>',
    "policyBar":'Usamos cookies para garantir que tem a melhor experiência com o nosso website. Ao continuar a utilizar o website, aceita a nossa utilização de cookies. <a title="[Ler mais]" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blanck">[Ler mais]</a>',
    "policyBarButton":'Aceitar',
    "header":{
        "registration":"ABERTURA DE CONTA",
        "personalDetails1":"Dados Pessoais 1",
        "personalDetails2":"Dados Pessoais 2",
        "financialDetails":"Dados Financeiros",
        "Experience":"Experiência",
        "Knowledge":"Conhecimento",
        "Acknowledgements":"Reconhecimentos",
        "previewPage":"Pré-visualização",
        "liveTrading":"OPERE COM UMA CONTA REAL"
    },
    "footer":{
        "copyright":"© 2020 ATFX.COM. Todos os direitos reservados.",
        "terms1":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf" target="_blank" rel="noopener">Política de Privacidade</a>',
        "terms2":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Cookies%20Policy%20EN.pdf" target="_blank" rel="noopener">Política de Cookies</a>',
        "terms3":'<a href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blank" rel="noopener">Termos e Condições</a>',
        "Legal":"Legal: A AT Global Markets (UK) Limited está autorizada e regulada pela Autoridade de Conduta Financeira (FCA) do Reino Unido. FCA número de registo (760555). Sede: 1st Floor, 32 Cornhill, London EC3V 3SG,United Kingdom. Empresa N.º 09827091",
        "riskWaring":'ALERTA DE INVESTIMENTO DE ALTO RISCO: Os CFDs são instrumentos complexos e acarretam um elevado risco de perda de dinheiro, de forma rápida, devido à alavacangem. <strong>59.38% das contas de investidores retalhistas perdem dinheiro, </strong>aquando do trading de CFDs com este prestador. Deverá considerar se entende como é que os CFDs funcionam e se poderá suportar suportar o elevado risco de perda de dinheiro. Por favor, leia a <a title="Risk Disclosure Policy" href="https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf" target="_blanck">Política de Alerta de Risco</a> na íntegra.',
        "otherInfo":"A informação constante deste site não se dirige aos residentes nos Estados Unidos, Bélgica ou qualquer país em particular fora do RU e não se destina a distribuição, ou uso por qualquer pessoa, de qualquer país ou jurisdição na qual tal distribuição ou uso seja contrário à lei local ou regulação. "
    },
    "headerMsg":{
        "personalDetails1":"Ao submeter esta informação, eu confirmo que concordo com os <a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>Termos Negociais Gerais</a> da e <a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>Política de Privacidade</a> da ATFX e poderei ser contactado sobre o meu pedido.",
        "personalDetails2":"Ao submeter esta informação, eu confirmo que concordo com os <a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>Termos Negociais Gerais</a> da e <a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>Política de Privacidade</a> da ATFX e poderei ser contactado sobre o meu pedido.",
        "financialDetails":"Como empresa regulada pela FCA, nós estamos obrigados a avaliar se os nossos produtos são adequados para si. As respostas que der determinarão se nós podemos prestar-lhe os nossos serviços.",
        "experience":"Como empresa regulada pela FCA, nós estamos obrigados a avaliar se os nossos produtos são adequados para si. As respostas que der determinarão se nós podemos prestar-lhe os nossos serviços.",
        "knowledge":"Como empresa regulada pela FCA, nós estamos obrigados a avaliar se os nossos produtos são adequados para si. As respostas que der determinarão se nós podemos prestar-lhe os nossos serviços.",
        "acknowledgements":"Ao preencher este cadastro, você confirma que entende que o FX marginalizado e os CFDs são produtos alavancados e colocam em risco o seu capital investido. Além disso, você confirma que é da sua responsabilidade monitorizar a sua conta."
    },
    "changeLanguage":"Alertar Língua",
    "back":"Voltar",
    "next":"Próximo",
    "finish":"Enviar",
    "personalDetails1":{
        "estimatedTime":"O tempo estimado para concluir o seu cadastro é de 5 minutos",
        "Gender":"Gênero",
        "genderSelect":{
            "M":"Masculino",
            "F":"Fêmeo",
            "O":"Outras"
        },
        "OtherGender":"Outro gênero",
        "Title":"Título",
        "titleSelect":{
            "Mr":"Sr..",
            "Mrs":"Sra.",
            "Ms":"Senhora.",
            "Miss":"Senhorita",
            "Dr":"Dr.",
            "Other":"Outras"
        },
        "OtherTitle":"Outro título",
        "First_Name":"Nome",
        "Surname":"Sobrenome",
        "Email":"E-mail",
        "Email_Confirm":"Confirmação de Email",
        "Lang":"Língua do E-mail",
        "emailLanguages":{
            "ENG":"Inglês",
            "CHT":"Chinês tradicional",
            "CHS":"Chinês simplificado",
            "ARA":"Árabe",
            "HIN":"Hindi",
            "ESP":"Espanhol",
            "ITA":"Italiano",
            "GER":"Alemão",
            "PTG":"Português",
        },
        "MT4_Currency":"Moeda da Conta de Trading",
        "MT4CurrencySelect":{
            "USD":"(USD) Dólar",
            "GBP":"(GBP) Libra",
            "EUR":"(EUR) Euro"
        },
        "Account_Type":"Tipo de Conta MT4",
        "Account_TypeSelect":{
            "CFDs":"CFDs",
            "SpreadBetting":"Spread Betting"
        },
        "Country":"País de Residência",
        "countrySelect":{
            "GBR":"Reino Unido",
            "CHN":"China",
            "TWN":"Taiwan, China",
            "ARE":"Emirados Árabes Unidos",
            "ALB":"Albânia",
            "AND":"Andorra",
            "AIA":"Anguila",
            "ATG":"Antígua e Barbuda",
            "ARG":"Argentina",
            "ARM":"Armênia",
            "ABW":"Aruba",
            "AUS":"Austrália",
            "AUT":"Áustria",
            "AZE":"Azerbaijão",
            "BHS":"Bahamas",
            "BHR":"Barém",
            "BGD":"Bangladesh",
            "BRB":"Barbados",
            "BLR":"Belarus",
            "BEL":"Bélgica",
            "BLZ":"Belize",
            "BEN":"Benin",
            "BMU":"Bermudas",
            "BOL":"Bolívia",
            "BWA":"Botsuana",
            "BVT":"Ilha Bouvet",
            "BRA":"Brasil",
            "BRN":"Brunei Darussalam",
            "BGR":"Bulgária",
            "BFA":"Burkina Faso",
            "BDI":"Burundi",
            "KHM":"Camboja",
            "CMR":"Camarões",
            "CPV":"cabo Verde",
            "CYM":"Ilhas Cayman",
            "CAF":"República Centro-Africana",
            "TCD":"Chade",
            "CHL":"Chile",
            "CCK":"Ilhas dos Cocos",
            "COL":"Colômbia",
            "COM":"Comores",
            "COK":"Ilhas Cook",
            "CRI":"Costa Rica",
            "CIV":"Costa do Marfim",
            "HRV":"Croácia",
            "CUB":"Cuba",
            "CYP":"Chipre",
            "CZE":"República Checa",
            "DNK":"Dinamarca",
            "DJI":"Djibuti",
            "DMA":"Dominica",
            "DOM":"República Dominicana",
            "EGY":"Egito",
            "SLV":"El Salvador",
            "ERI":"Eritréia",
            "EST":"Estônia",
            "ETH":"Etiópia",
            "FJI":"Fiji",
            "FIN":"Finlândia",
            "FRA":"França",
            "PYF":"Polinésia Francesa",
            "GAB":"Gabão",
            "GEO":"Georgia",
            "DEU":"Alemanha",
            "GHA":"Gana",
            "GIB":"Gibraltar",
            "GRC":"Grécia",
            "GRL":"Gronelândia",
            "GRD":"Granada",
            "GLP":"Guadalupe",
            "GTM":"Guatemala",
            "GIN":"Guiné",
            "GNB":"Guiné-Bissau",
            "HTI":"Haiti",
            "HMD":"Ilhas Heard e McDonald",
            "HND":"Honduras",
            "HUN":"Hungria",
            "ISL":"Islândia",
            "IND":"Índia",
            "IDN":"Indonésia",
            "IRL":"Irlanda",
            "ISR":"Israel",
            "ITA":"Itália",
            "JAM":"Jamaica",
            "JPN":"Japão",
            "JOR":"Jordânia",
            "KAZ":"Cazaquistão",
            "KEN":"Quênia",
            "KIR":"Kiribati",
            "KOR":"República da Coreia",
            "KWT":"Kuwait",
            "KGZ":"Quirguistão",
            "LVA":"Letônia",
            "LSO":"Lesoto",
            "LBR":"Libéria",
            "LBY":"Líbia",
            "LIE":"Liechtenstein",
            "LTU":"Lituânia",
            "LUX":"Luxemburgo",
            "MAC":"Macau",
            "MDG":"Madagáscar",
            "MWI":"Malawi",
            "MYS":"Malásia",
            "MDV":"Maldivas",
            "MLI":"Mali",
            "MLT":"Malta",
            "MHL":"Ilhas Marshall",
            "MTQ":"Martinica",
            "MUS":"Maurício",
            "MYT":"Mayotte",
            "MEX":"México",
            "MDA":"Moldávia",
            "MCO":"Mônaco",
            "MNG":"Mongólia",
            "MNE":"Montenegro",
            "MSR":"Montserrat",
            "MAR":"Marrocos",
            "MOZ":"Moçambique",
            "NAM":"Namíbia",
            "NRU":"Nauru",
            "NLD":"Países Baixos",
            "NCL":"Nova Caledônia",
            "NZL":"Nova Zelândia",
            "NIC":"Nicarágua",
            "NER":"Níger",
            "NGA":"Nigéria",
            "NIU":"Niue",
            "NFK":"Ilha Norfolk",
            "NOR":"Noruega",
            "OMN":"Omã",
            "PAK":"Paquistão",
            "PSE":"Palestina",
            "PRY":"Paraguai",
            "PER":"Peru",
            "PHL":"Filipinas",
            "PCN":"Pitcairn",
            "POL":"Polônia",
            "PRT":"Portugal",
            "QAT":"Catar",
            "ROU":"Roménia",
            "RUS":"Rússia",
            "RWA":"Ruanda",
            "SHN":"Santa Helena",
            "KNA":"São Cristóvão e Névis",
            "LCA":"Santa Lúcia",
            "SPM":"São Pedro e Miquelon",
            "VCT":"São Vicente e Granadinas",
            "WSM":"Samoa",
            "SMR":"San Marino",
            "STP":"São Tomé e Príncipe",
            "SAU":"Arábia Saudita",
            "SEN":"Senegal",
            "SRB":"Sérvia",
            "SYC":"Seychelles",
            "SLE":"Serra Leoa",
            "SGP":"Cingapura",
            "SVK":"Eslováquia",
            "SVN":"Eslovênia",
            "ZAF":"África do Sul",
            "ESP":"Espanha",
            "SUR":"Suriname",
            "SJM":"Svalbard e Jan Mayen",
            "SWZ":"Suazilândia",
            "SWE":"Suécia",
            "CHE":"Suíça",
            "TJK":"Tajiquistão",
            "TZA":"Tanzânia",
            "THA":"Tailândia",
            "TLS":"Timor-Leste",
            "TGO":"Togo",
            "TON":"Tonga",
            "TTO":"Trinidad e Tobago",
            "TUN":"Tunísia",
            "TUR":"Peru",
            "TKM":"Turcomenistão",
            "TCA":"Ilhas Turks e Caicos",
            "TUV":"Tuvalu",
            "UKR":"Ucrânia",
            "URY":"Uruguai",
            "UZB":"Uzbequistão",
            "VUT":"Vanuatu",
            "VAT":"Vaticano",
            "VEN":"Venezuela",
            "VNM":"Vietnã",
            "WLF":"Wallis e Futuna",
            "ESH":"Saara Ocidental",
            "ZMB":"Zâmbia",
            "DZA":"Argélia",
            "AGO":"Angola",
            "BIH":"Bósnia e Herzegovina",
            "GMB":"Gâmbia",
            "GUY":"Guiana",
            "IRQ":"Iraque",
            "RKS":"Kosovo",
            "LBN":"Líbano",
            "MKD":"Macedônia",
            "NPL":"Nepal",
            "PAN":"Panamá",
            "PNG":"Papua Nova Guiné",
            "LKA":"Sri Lanka"
        }
    },
    "personalDetails2":{
        "Addr":"Endereço Linha 1",
        "Addr2":"Endereço Linha 2",
        "City":"Cidade",
        "Postcode":"Código postal",
        "Building_Name":"Número / nome do prédio",
        "Street":"Rua",
        "Province":"Província",
        "birthDate":"Data de nascimento",
        "birthYear":"Ano",
        "birthMonth":"Mês",
        "birthSecond":"Dia",
        "Nationality":"Nacionalidade",
        "isHavePass":"você tem passaporte",
        "PotSelect":{
            "havePot":"Sim",
            "noPot":"Não"
        },
        "NAT_ID":"Número do passaporte",
        "Phone":"Celular",
        "countryPlace":"País de residência fiscal",
        "TIN":"NIF (Número de Identificação Fiscal)",
        "Doc_Type":"Tipo de Identidade",
        "idTypeSelect":{
            "POT":"Passaporte",
            "IDC":"Carteira de identidade",
            "DRI":"Carteira de motorista"
        },
        "Doc_No":"Número de identificação",
        "bankCardType":"Tipo de Cartão Bancário",
        "bankCardTypeSelect":{
            "DR":"Cartão de débito",
            "CR":"Cartão de crédito"
        },
        "Addr_Country":"País de Residência",
        "Bank_Card_No":"Número do banco",
        "bankCardNoConfirm":"Confirmação do número de conta bancária",
        "Bank":"Banco",
        "bankSelect":{
            "ICBK":"BANCO INDUSTRIAL E COMERCIAL DA CHINA",
            "ABOC":"BANCO AGRICULTURAL DA CHINA",
            "PCBC":"CORPORAÇÃO DE BANCO DE CONSTRUÇÃO DA CHINA",
            "BKCH":"BANCO DE CHINA LIMITADA",
            "CMBC":"BANCO DOS MERCADORES DA CHINA",
            "COMM":"BANCO DE COMUNICAÇÕES",
            "MSBC":"CHINA MINSHENG BANKING CORPORATION, LIMITED",
            "EVER":"BANCO DE EVERBRIGHT DA CHINA",
            "SPDB":"BANCO DE DESENVOLVIMENTO DE SHANGHAI PUDONG",
            "FJIB":"BANCO INDUSTRIAL",
            "CIBK":"CITIC BANK CORPORATION LIMITED",
            "PSBC":"BANCO DE ECONOMIA POSTAL DA CHINA",
            "SZCB":"SHENZHEN DEVELOPMENT BANK CO., LTD",
            "GDBK":"BANCO DE GUANGFA DA CHINA",
            "BOSH":"BANCO DE XANGAI",
            "BJCN":"BANCO DE BEIJING",
            "HXBK":"BANCO HUA XIA",
            "other":"OUTROS"
        },
        "OtherBank":"Outros bancos",
        "Beneficiary_Name":"Nome do beneficiário",
        "SWIFT_Code":"Código Swift do Banco",
        "Branch_Name":"Nome da Agência Bancária",
        "Bank_Addr":"Endereço da Agência Bancária",
        "Branch_Province":"Província da Agência Bancária",
        "Branch_City":"Cidade da Agência Bancária",
        "bankCardImg":"Imp do Cartão Bancário",
        "IBAN_Code":"IBAN",
        "docFrontImgword":"Cópia da Identificação (Frente)",
        "docBackImgword":"Cópia da Identificação (Verso)",
        "addressUpload":"Comprovante de endereço",
        "addressUpload2":"Comprovante de endereço 2",
        "addressUploadTxt1":"Comprovantes aceitáveis-com data dentro de 3 meses: fatura da eletricidade / gás / extrato bancário / cartão de residência / carteira de motorista / carteira de Identidade / hukou (se o requerente não for o proprietário da casa, há necessidade de combinar as imagens de submissão da página 1);",
        "addressUploadTxt2":"o comprovante de endereço não pode ser o mesmo do comprovante de identidade.",
        "docImgword1":"anexo de documento 1",
        "docImgword2":"anexo de documento 2",
        "docImgword3":"anexo de documento 3",
        "docImgword4":"anexo de documento 4",
        "docImgword5":"anexo de documento 5",
        "fileUpload":{
            "imgtUpload":"Enviar",
            "uploadFileArr": [{
                "labelTxt": "Cópia da Identificação 1",
                "ValidateNull": "Por favor selecione",
                "sizeLimit": "A imagem do documento de Identidade 1 não pode exceder 5MB"
              }, {
                "labelTxt": "Cópia da Identificação 2",
                "ValidateNull": "Por favor selecione",
                "sizeLimit": "A imagem do documento de Identidade 2 não pode exceder 5MB"
              }, {
                "labelTxt": "Comprovante de endereço",
                "ValidateNull": "Por favor selecione",
                "sizeLimit": "A imagem do comprovante de endereço não pode exceder 5MB."
              }, {
                "labelTxt": "Comprovante de endereço 2",
                "ValidateNull": "Por favor selecione",
                "sizeLimit": "A imagem do comprovante de endereço não pode exceder 5MB."
              }, {
                "labelTxt": "Outros arquivos",
                "ValidateNull": "Por favor selecione",
                "sizeLimit": "Outros arquivos não podem exceder 5MB!"
              }],
            "addressUploadHtml":{
                "sizeLimit":"O tamanho do arquivo não poderá exceder 5MB",
                "upload_your_documents":"Enviar Seus Documentos de Identidade",
                "documents_not_ready":"OS DOCUMENTOS AINDA NÃO ESTÃO PRONTOS?",
                "noe":"*O requerente terá que proporcionar uma cópia do documento de identificação e comprovante de endereço, para verificar a sua identidade. Nós não aceitamos: faturas de celular, extratos de cartões de crédito ou quaisquer faturas de serviços móveis; recibos de seguros; fatura de bens/serviços adquiridos.",
                "noe2":"Se não tiver os documentos exigidos neste momento, poderá ainda assim concluir o seu pedido. <br/><b>No entanto, não poderá operar até que nós recebamos os documentos exigidos.<b/>",
                "header1":"Comprovante de Identidade (Exigência mínima: $Logic)",
                "list1":"Pedimos cópias a cores do documento de identificação/passaporte original emitido pelo Estado. Para a Identificação, pedimos a frente e o verso do cartão.",
                "list1_new":"Pedimos uma cópia a cores, clara, do passaporte original, com os quatro cantos visíveis.",
                "header2":"Comprovante de Endereço (Qualquer $Logic das seguintes opções)",
                "list2":"<ol class='list-style-position:inside'><li>Comprovante de morada (água, electricidade, gás) - emitidos nos últimos 3 meses,</li><li>Extrato Bancário emitido há menos de 3 meses, </li><li>Podemos aceitar registos de residência/registos de propriedade, incluindo o Hukou Chinês - mas os mesmos estão sujeitos a revisão.</li><li>Terão de ser facultados o contrato de aluguel actual e uma factura que comprove a residência (gás, água, electricidade), pagas nos últimos 3 meses.</li><li>Uma fatura fiscal recente, se tiver sido emitida há menos de 6 meses.</li><li>Uma fatura de Telefone fixo, emitida há menos de 3 meses.</li></ol>",
                "strongTxt":"<strong>Como parte das nossas exigências normativas, nós podemos pedir documentos adicionais, relativos ao seu cadastro.</strong>"
            }
        },
        "isHaveCitizen":"Você é Cidadão dos Estados Unidos da América?",
        "CitizenSelect":{
            "Y":"Sim",
            "N":"Não"
        },
        "citizen_Tip":"Infelizmente, nós não podemos abrir uma conta para cidadãos dos EUA",
        "isDualCitizenship":"Você é residente fiscal fiscal fora do país que atualmente você reside?",
        "DualCitizenshipSelect":{
            "Y":"Sim",
            "N":"Não"
        },
        "Dual_Nationality":"País",
        "IS_Politically_Person": "É uma Pessoa Politicamente Exposta?",
        "IS_Politically_Exposed":'Pessoa politicamente exposta significa uma pessoa singular a quem são ou foram confiadas funções públicas proeminentes na República ou noutro país,um parente direto dessa pessoa, bem como uma pessoa conhecida por ser associada próxima dessa pessoa:<br/>Desde que, para efeitos da presente definição, "função pública proeminente" significa qualquer das seguintes funções públicas:<br/>a) chefes de Estado, chefes de governo, ministros e ministros-adjuntos ou adjuntos;<br/>b) membros do parlamento ou de órgãos legislativos similares;<br/>c) membros dos órgãos de direção dos partidos políticos;<br/>d) membros dos tribunais superiores, dos tribunais constitucionais ou de outros órgãos jurisdicionais de alto nível,cujas decisões não sejam objeto de novo recurso, exceto em circunstâncias excecionais;<br/>e) membros dos tribunais de contas ou dos conselhos de administração dos bancos centrais;<br/>f) embaixadores, encarregados de negócios e altos oficiais das forças armadas;<br/>g) membros dos órgãos de administração, de direção ou de fiscalização de empresas públicas;<br/>h) diretores, diretores-adjuntos e membros do conselho de administração ou funções equivalentes numa organização internacional;<br/>I) autarca: Desde que nenhuma das funções públicas referidas nas alíneas a) a<br/>i) seja entendida como abrangendo funcionários de grau médio ou mais inferior;<br/>Desde que os "parentes próximos de uma pessoa politicamente exposta " incluam os seguintes elementos:<br/>a) o cônjuge, ou uma pessoa considerada equivalente ao cônjuge, de uma pessoa politicamente exposta;<br/>b) os filhos e respetivos cônjuges, ou pessoas consideradas equivalentes ao cônjuge de uma pessoa politicamente exposta;<br/>c) pais de uma pessoa politicamente exposta; Contanto que "pessoas conhecidas<br/>por serem associadas próximas de uma pessoa politicamente exposta" signifique uma pessoa singular:<br/>a) que seja conhecida por ter a titularidade benéfica conjunta de entidades jurídicas ou de acordos legais,ou quaisquer outras relações estreitas de negócios, com uma pessoa politicamente exposta;<br/>b) que detenha a titularidade exclusiva de uma entidade jurídica ou de acordo jurídicoque tenha sido celebrado em benefício de facto de uma pessoa politicamente exposta.<br/>',
        "IS_Politically_Person_Select": {
            "Y":"Sim",
            "N":"Não"
        },
    },
    "financialDetails":{
        "Emp_Status":"Situação de Emprego",
        "employmentStatusSelect":{
            "b":"Empregado",
            "a":"Autônomo",
            "c":"Estudante",
            "e":"Aposentado",
            "d":"Desempregado"
        },
        "Freelance_OwnACompany":"Freelance / Empresário",
        "Freelance_OwnACompany_select":[
            "Freelance",
            "Empresário"
        ],
        "Position":"Posição",
        "FD_Position_select":[
            "Gerente de Categoria C ex. CEO, CFO, CIO",
            "Gerente Sénior",
            "Gerente Geral / Médio",
            "Supervisor",
            "Cargo Administrativo ",
            "Funcionário",
            "Júnior",
            "Outras (Por favor especifique)"
        ],
        "Employer":"Nome da empresa",
        "Biz_Nature":"Natureza do negócio",
        "financialRegulator":"O seu empregador está autorizado pela FCA ou outra entidade financeira reguladora?",
        "financialRegulatorSelect":{
            "Y":"Sim",
            "N":"Não"
        },
        "Industry_Sector":"Indústria / Sector",
        "Industry_Sector_select":[
            "Contabilidade",
            "Publicidade/Mídia",
            "Informática/Internet/Comunicação/Electrónica",
            "Educação/Formação",
            "Energia / matérias-primas",
            "Serviços Financeiros (Finanças/Banco/Seguros)",
            "Estado/Não lucrativo",
            "Recursos Humanos",
            "Legal",
            "Marketing",
            "Logística/Transportes",
            "Farmacêutica/Médica",
            "Serviços Profissionais",
            "Imobiliário / Construção",
            "Indústria de Serviços",
            "Comércio / Consumo / Fabrica / Operações",
            "Outros (Por favor, especifique)"
        ],
        "Annual_Income":"Rendimento Anual",
        "Annual_Income_word":"Isto inclui todos os rendimentos ganhos, incluindo salários, pensões, juros, dividendos, rendimentos imobiliários, etc.",
        "Total_Saving_Investments":"Poupança e Investimentos Totais",
        "Total_Saving_word":"Isto inclui todas as contas bancárias ou de corretagem, títulos, obrigações, investimento no mercado de capitais, etc.",
        "Total_Saving_Investments_select":[
            "Acima de US$500,000",
            "US$200,000-US$499,999",
            "US$100,000-US$199,999",
            "US$50,000-US$99,999",
            "US$25,000-US$49,999",
            "US$10,000-US$24,999",
            "US$2,000-US$9,999",
            "Menos de US$2,000"
        ],
        "liquidNetWorth":"Receita Líquida (excluindo residência privada)",
        "financialPortfolio":"Valor do seu portfólio financeiro",
        "annualIncomeSelect":[
            "Acima de  US$200,000",
            "US$100,000-US$199,999",
            "US$50,000-US$99,999",
            "US$25,000-US$49,999",
            "US$10,000-US$24,999",
            "Menos de US$10,000"
        ],
        "fundsSource":"Fonte desses fundos",
        "fundsSourceSelect":[
            "Nenhuma",
            "Renda Familiar e do Cônjuge",
            "Benefícios do Governo",
            "Empréstimo/Crédito",
            "Pensão",
            "Rendimento de Propriedades",
            "Outras (Por favor especifique)"
        ],
        "Funds_Source":"Outras fontes de rendimento",
        "Intend_Deposit":"Que quantía você pretende depositar?",
        "intendDepositSelect":[
            "Acima de US$100,000",
            "US$80,000 – US$99,999",
            "US$50,000 – US$79,999",
            "US$25,000 – US$49,999",
            "US$10,000 – US$24,999",
            "Menos de US$10,000"
        ],
        "Other_Industry_Sector":"Outra Indústria / Sector",
        "Other_Position":"Outra Posição",
        "Other_Biz_Nature":"Outra Natureza de negócio",
        "Other_Funds_Source":"Outras fontes de rendimento",
        "Afford_To_Lose_Error":"CFDs são produtos de alto risco, você só deve negociar com dinheiro que você pode dar-se ao luxo de perder.",
        "Afford_To_Lose":"Pode dar-se ao luxo de perder os fundos que planeia investir?",
        "Afford_To_Lose_Select": {
            "Y": "Sim",
            "N": "Não"
        },
        "Open_Trading_Account":"Por que é que você quer abrir uma conta de negociação com a ATFX?",
        "Open_Trading_Account_Select": {
            "0": "Curto - especulação a curto prazo nos mercados financeiros",
            "1": "Curto - cobertura a médio prazo face a exposições em investimentos existentes",
            "2": "Curto - especulação a curto prazo nos mercados financeiros e cobertura face a exposições nos investimentos existentes"
        },
        "ATFX_Client_Pro":"A ATFX considerou os seus produtos como adequados apenas para clientes com os objetivos acima, por favor, não prossiga com este pedido, se os seus objetivos diferirem dos listados acima.",
        "Annual_Income_Total":"Por favor, indique o seu rendimento anual real",
        "Saving_Investments_Money":"Por favor, indique o seu total real de poupança e investimentos",
    },
    "Experience":{
        "experienceLabel":"Nos últimos três anos, quantas vezes você operou os instrumentos financeiros que seguem, tomando as suas próprias decisões de trading?",
        "Futures_Options":"Futuros / Opções",
        "Futures_Options_select":[
            "Em mais de 40 ocasiões",
            "De 15 a 40 ocasiões",
            "De 1 a 15 ocasiões",
            "Nunca"
        ],
        "CFDs_Spread_Bets":"CFDs, Derivados de Câmbio ou Spread Betting",
        "CFDs_Spread_Bets_select":[
            "Em mais de 40 ocasiões",
            "De 15 a 40 ocasiões",
            "De 1 a 15 ocasiões",
            "Nunca"
        ],
        "Derivative_Trade_over2":"Nos últimos doze meses, você efetuou pelo menos, duas operações por trimestre, em Spot FX / CFDs / Opções / Futuros ou Spread Betting, nas quais tenha tomado as suas próprias decisões de trading?",
        "Derivative_Trade_over2_select":{
            "b":"Sim",
            "a":"Não"
        },
        "Derivative_Trade_over40":"Nos últimos três anos, você fez quarenta operações, no período de doze meses, em Spot FX / CFDs / Opções / Futuros ou Apostas de Spread?",
        "Derivative_Trade_over40_select":{
            "b":"Sim",
            "a":"Não"
        },
        "Average_Annual_Investment":"Qual foi o volume anual médio dos montantes investidos nas suas transações anteriores nos produtos financeiros que seleccionou acima?",
        "Average_Annual_Investment_select": {
            "0": "Eu nunca investi",
            "1": "Menos de $500 ",
            "2": "Entre $500 e $2.500",
            "3": "Entre $2.500 e $10.000",
            "4": "Mais de $10.000"
        },
        "Average_Leverage_Level":"Qual foi o nível médio de alavancagem que usou para negociar os produtos financeiros que selecionou acima?",
        "Average_Leverage_Level_select": {
            "0": "Nunca usei alavancagem",
            "1": "Até 1:10",
            "2": "Entre 1:10 - 1:25",
            "3": "Entre 1:25 - 1:50",
            "4": "Entre 1:50 - 1:100",
            "5": "Mais do que 1:100"
        }
    },
    "Knowledge":{
        "DT_Work_Experience":"Você já trabalhou num cargo para o qual fosse exigido conhecimento sobre trading de derivados alavancados?",
        "DT_Work_Experience_select":{
            "txt1":"Sim",
            "txt2":"Não",
            "subTxt1":"Eu tenho, pelo menos, 3 anos de experiência de trabalho",
            "subTxt2":"Eu tenho menos de 3 anos de experiência de trabalho ou, pelo menos, um ano de experiência de  investimento por conta própria."
        },
        "DT_Qualification":"Você tem alguma qualificação que lhe tenha dado entendimento sobre trading de derivados alavancados?",
        "DT_Qualification_select":{
            "txt1":"Sim",
            "txt2":"Não",
            "subTxt1":"Eu tenho qualificação profissional ou grau, tais como CFA, MBA, BSC ou MA",
            "subTxt2":"Eu tenho qualificação ou grau em finanças, economia, contabilidade ou alguma área similar"
        },
        "K_Sell_Position":"Se vender um lot de ouro (XAUUSD) ao preço de 1200 e o mercado se mover para o preço de 1300, você vai ganhar ou perder dinheiro?",
        "K_Sell_Position_b":"Se vender um lot de ouro XAUUSD.sb ao preço de 1200 e o mercado se mover até ao preço de 1300, você vai ganhar ou perder dinheiro?",
        "K_Sell_Position_select":[
            "Perder",
            "Ganhar"
        ],
        "Closing_Order":"Para evitar que a sua conta perca mais do que o seu montante pré-determinado. Você limitaria a sua perda colocando um stop loss ou take profit?",
        "Closing_Order_select":[
            "Stop Loss",
            "Take Profit"
        ],
        "K_Profit_Change":"Você entende que a alavancagem resulta num risco mais elevado para o seu capital quando você opera produtos CFD alavancados?",
        "K_Profit_Change_b":"Você entende que a alavancagem resulta num risco mais elevado para o seu capital quando você opera produtos CFD alavancados?",
        "K_Profit_Change_select":[
            "Entendo",
            "Não Entendo"
        ],
        "K_Margin":"Qual é que seria a margem necessária para 1 lot (100,000) USD/JPY, se a sua margem for de 1:20?",
        "K_Margin_select":[
            "USD 5,000",
            "USD 50,000",
            "USD 100,000"
        ]
    },
    "Acknowledgements":{
        "A1":"Confirmo que as informações fornecidas por mim são corretas e completas, e comprometo-me a notificá-lo no caso que estas informações sofram alterações",
        "A2":"Li, compreendi e concordei em ficar vinculado ao Acordo de Cliente da AT Global Markets que me foi facultado.",
        "A2_txt":"o Acordo do Cliente da AT Global Markets",
        "A2_link":"<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>o Acordo do Cliente da AT Global Markets</a>",
        "A3":"Li, compreendi e concordei em ficar vinculado à Declaração de Divulgação de Risco da AT Global Markets que me foi facultado",
        "A3_txt":"a Declaração de Divulgação de Risco da AT Global Markets",
        "A3_link":"<a href='https://www.atfx.com/uk/wp-content/uploads/standard-terms-uk-en.pdf' target='_blank'>a Declaração de Divulgação de Risco da AT Global Markets</a>",
        "A4":"Li, compreendi e concordei com a Política de Execução de Ordens da AT Global Markets e Política de Conflitos que me foi facultada.",
        "A4_txt":"a Política de Execução de Ordens e Política de Conflitos da AT Global Markets",
        "A4_link":"<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>a Política de Execução de Ordens</a> e <a href='https://www.atfx.com/uk/wp-content/uploads/conflict-of-interests-policy-uk-en.pdf' target='_blank'>Política de Conflitos da AT Global Markets</a>",
        "header":"Ao preencher este cadastro, você confirma que entende que o FX marginalizado e os CFDs são produtos alavancados e colocam em risco o seu capital investido. Além disso, você confirma que é da sua responsabilidade monitorizar a sua conta.",
        "age":"Você confirma que tem idade igual ou superior a 18 anos;",
        "message":"A informação fornecida neste pedido é verdadeira e está correcta, você se compromete a notificar-nos se houver qualquerr alterações a esta informação;",
        "receive":{
            "text":"Você leu, entendeu e concorda com a nossa",
            "list": [
                "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Standard%20Terms%20of%20Business%20EN%20-%20V08.18.pdf' target='_blank'>Termos Padrão de Negócios</a>",
                "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Order%20Execution%20Policy%20EN%20-%20V10.18.pdf' target='_blank'>Política de Execução de Ordens</a>",
                "<a href='https://f.hubspotusercontent10.net/hubfs/6693213/ATFX%20Legal%20Documents%202020%20(All%20Entities)/ATFX%20FCA%20Legal%20Documents%202020/FCA%20General%20Legal%20Documents%20and%20Terms%20and%20Conditions/ATFX%20FCA%20Privacy%20Notice%20EN%2031.08.pdf' target='_blank'>Política de Privacidade</a>",
                // "<a href='https://www.atfx.com/uk/wp-content/uploads/introducing-broker-disclosure-en.pdf' target='_blank'>Introducer Broker Disclosure</a>",
                "<a href='https://www.atfx.com/pt/condicoes-legais' target='_blank'>Documentos Legais e Termos e Condições</a>"
            ]
        },
        "A_select":{
            "text":"Li, compreendo e concordo com todos os termos.",
            "Y":"Li, compreendo e concordo com todos os termos."
        },
        "checkboxTxt_A1":"Li, compreendo e concordo com todos os termos e condições.",
        "checkboxTxt_A2":"Entendo que os CFDs são produtos alavancados e que o seu desempenho pode ser volátil.",
        "checkboxTxt_A3":"Compreendo que é minha responsabilidade controlar e gerir a minha conta.",
        "checkboxTxt_A4":"Compreendo que com operações de produtos alavancados, é possível que perca mais do que meu investimento inicial.",
        "Marketing_Email_Preference":"Concordo em receber informações da ATFX que possam conter materiais de marketing.",
        "Marketing_automatically":"Entendo que posso optar por não receber comunicações de marketing imediatamente, contactando a <a href='https://www.atfx.com/pt/sobre-nos/fale-connosco' target='_blank'>Equipa de Atendimento Ao Cliente</a>.",
        "Marketing_Email_Preference_select":{
            "Y":"Sim",
            "N":"Não"
        },
        "Hear_ATFX":"Como você ficou sabendo da ATFX?",
        "OtherHearATFX":"Outras formas",
        "hearATFXSelect":{
            "Recommendation":"Recomendação",
            "SearchEngine":"Motor de busca",
            "MediaAdvertising":"Publicidade em Mídia",
            "Partnership":"Parceria",
            "Other":"Outros"
        },
        "Parent_IB_Code":"Código de Referência",
        "Rec_Type":"Tipo de Referência",
        "recTypeSelect":{
            "AA1":"AA1",
            "AA2":"AA2",
            "AA3":"AA3",
            "A01":"A01",
            "A02":"A02",
            "A03":"A03",
            "A00":"A00",
            "NAN":"Sem Referência"
        },
        "recGroup":"Grupo de Referência",
        "recGroupSelect":{
            "A":"A",
            "AA":"AA"
        }
    },
    "customErrMsg":{
        "fieldIsRequired":{
            "Gender":"Por favor selecione",
            "OtherGender":"Outro gênero",
            "Title":"Por favor selecione",
            "OtherTitle":"Outro título",
            "First_Name":"Nome",
            "Surname":"Sobrenome",
            "Email":"Endereço de e-mail",
            "Email_Confirm":"Confirmar e-mail",
            "Lang":"Por favor selecione",
            "Country":"Por favor selecione",
            "MT4_Currency":"Por favor selecione",
            "Account_Type":"Por favor selecione",
            "Addr":"Endereço",
            "Addr2":"Endereço linha 2",
            "City":"Cidade",
            "Postcode":"Código postal",
            "Building_Name":"Número / nome do prédio",
            "Street":"Rua",
            "Province":"Província",
            "Birth_Date_Year":"Data de nascimento",
            "Birth_Date_Month":"Data de nascimento",
            "Birth_Date_Day":"Data de nascimento",
            "Nationality":"Nacionalidade",
            "isHavePass":"Por favor selecione",
            "NAT_ID":"Número do passaporte",
            "Phone":"Telefone",
            "Doc_Type":"Por favor selecione",
            "Doc_No":"Número de identificação",
            "Addr_Country":"Por favor selecione",
            "Bank_Card_No":"Número do banco",
            "Bank":"Por favor selecione",
            "OtherBank":"Outros bancos",
            "Beneficiary_Name":"Nome de Beneficiário",
            "Branch_Name":"Nome da Agência Bancária",
            "Bank_Addr":"Endereço da Agência Bancária",
            "Branch_Province":"Província da Agência Bancária",
            "Branch_City":"Cidade da Agência Bancária",
            "FD_Emp_Status":"Por favor selecione",
            "FD_Position":"Posição",
            "FD_Employer":"Nome da Empresa",
            "FD_Biz_Nature":"Por favor, indique os atributos do negócio",
            "FD_FCA_AUTH":"Por favor selecione",
            "FD_Annual_Income":"Por favor selecione",
            "FD_Liquid_Net_Worth":"Por favor selecione",
            "FD_Portfolio_Value":"Por favor selecione",
            "FD_Funds_Source":"Por favor selecione",
            "FD_Funds_Other":"Por favor selecione",
            "E_Forex_Exp":"Por favor selecione",
            "E_Forex_Trade_No":"Por favor selecione",
            "E_Derivative_Exp":"Por favor selecione",
            "E_Derivative_Trade_No":"Por favor selecione",
            "E_Equity_Exp":"Por favor selecione",
            "E_Equity_Trade_No":"Por favor selecione",
            "K_A":"Por favor selecione",
            "K_A_Detail":"Detalhes",
            "K_B":"Por favor selecione",
            "K_B_Detail":"Detalhes",
            "K_C":"Por favor selecione",
            "K_C_Detail":"Detalhes",
            "K_D":"Por favor selecione",
            "K_E":"Por favor selecione",
            "K_F":"Por favor selecione",
            "K_G":"Por favor selecione",
            "K_H":"Por favor selecione",
            "A1":"Por favor selecione",
            "A2":"Por favor selecione",
            "A3":"Por favor selecione",
            "A4":"Por favor selecione",
            "checkList":"Por favor selecione",
            "Emp_Status":"Por favor selecione",
            "Freelance_OwnACompany":"Por favor selecione",
            "Industry_Sector":"Por favor selecione",
            "Position":"Por favor selecione",
            "Employer":"Nome da Empresa",
            "Biz_Nature":"Por favor, indique os atributos do negócio",
            "Annual_Income":"Por favor selecione",
            "Total_Saving_Investments":"Por favor selecione",
            "Funds_Source":"Por favor selecione",
            "Intend_Deposit":"Por favor selecione",
            "Other_Industry_Sector":"Outra Indústria / Sector",
            "Other_Position":"Outra Posição",
            "Other_Biz_Nature":"Outra Natureza de negócio",
            "Other_Funds_Source":"Outras fontes de renda",
            "Futures_Options":"Por favor selecione",
            "CFDs_Spread_Bets":"Por favor selecione",
            "Derivative_Trade_over2":"Por favor selecione",
            "Derivative_Trade_over40":"Por favor selecione",
            "DT_Work_Experience":"Por favor selecione",
            "DT_Qualification":"Por favor selecione",
            "K_Sell_Position":"Por favor selecione",
            "Closing_Order":"Por favor selecione",
            "K_Profit_Change":"Por favor selecione",
            "K_Margin":"Por favor selecione",
            "IBAN_Code":"IBAN",
            "Hear_ATFX":"Por favor selecione",
            "OtherHearATFX":"Por favor, insira",
            "Rec_Type":"Por favor selecione",
            "Parent_IB_Code":"Código de Referência",
            "isHaveCitizen":"Por favor selecione",
            "isDualCitizenship":"Por favor selecione",
            "Dual_Nationality":"Por favor selecione",
            "IS_Politically_Person":"Por favor selecione",
            "Afford_To_Lose":"Por favor selecione",
            "Open_Trading_Account":"Por favor selecione",
            "Annual_Income_Total":"Por Favor, Introduza",
            "Saving_Investments_Money":"Por Favor, Introduza",

        }
    },
    "errors":{
        "fieldIsRequired":"Endereço de Email",
        "invalidFormat":"Formato inválido!",
        "numberTooSmall":"O número é muito curto! Minimo: {0}",
        "numberTooBig":"O número é muito longo! Máximo: {0}",
        "invalidNumber":"Número inválido",
        "textTooSmall":"O texto é muito curto! Atual: {0}, Mínimo: {1}",
        "textTooBig":"O texto é muito longo! Atual: {0}, Máximo: {1}",
        "thisNotText":"Isto não é um texto!",
        "thisNotArray":"Isto não é uma matriz!",
        "selectMinItems":"Seleccione {0} itens mínimos!",
        "selectMaxItems":"Seleccione {0} itens máximos!",
        "invalidDate":"Informação inválida!",
        "dateIsEarly":"A data é muito prematura! Actual: {0}, Mínimo: {1}",
        "dateIsLate":"A data é muito tardia! Actual: {0}, Máximo: {1}",
        "invalidEmail":"O Endereço de E-mail não está disponível!",
        "invalidURL":"URL inválido!",
        "invalidCard":"Formato de cartão inválido!",
        "invalidCardNumber":"Número de cartão inválido!",
        "invalidTextContainNumber":"Texto inválido! Não pode conter números ou caracteres especiais",
        "invalidTextContainSpec":"Texto inválido! Não pode conter caracteres especiais",
        "incorrectComfirm":"As duas entradas são inconsistentes",
        "invalidBirthDate":"Aceitação de pedidos de idades entre os 18-69 anos",
        "invalidParentClnID":"por favor, insira um número inferior a 12 dígitos!",
        "docImgFrontSizeLimit":"A imagem do documento de Identidade (frente) não pode exceder 2MB",
        "docImgBackSizeLimit":"A imagem do documento de identidade (verso) não pode exceder 2MB！",
        "imgSizeLimit":"A imagem do comprovante de endereço não pode exceder 2MB.",
        "bankCardNoTopTwo":"Os dois primeiros dígitos do cartão do banco estão fora de linha",
        "bankCardNoLnegth":"Por favor, introduza um número de 16-19",
        "dayErrors1":"O ano é um ano bissexto e não há dia",
        "dayErrors2":"neste ano, o dia não existe",
        "dayErrors3":"O dia não existe neste mês",
        "emailError":"O Endereço de E-mail não está disponível",
        "DocTypeNoError":"O Número de Identificação é ilegal",
        "DocFrontImg":"Envie, por favor, a imagem do Documento de Identificação (frente)",
        "DocBackImg":"Envie, por favor, a imagem do Documento de Identificação (verso)",
        "ProofofAddress":"Envie, por favor, o comprovativo de endereço",
        "Doc_No":"Por favor, introduza o N.º de Identificação",
        "Phone":"Telefone",
        "Bank_Card_No":"Número do Banco",
        "Birth_Date_Second":"Data de nascimento",
        "phoneError":"Formato de Telefone Incorrecto",
        "bankNumError":"Formato do Número do Banco Incorrecto",
        "numType":"por favor, insira o número",
        "bankCodeError":"Formato do Código IBAN do Banco Incorrecto"
    },
    "messages":{
        "fieldsWillBeReset":"Todos os dados serão restabelecidos, por favor confirme",
        "completeTip1":"Por favor, verifique o seu E-mail. Obrigado.",
        "completeTip2":"Concluído! Obrigado.",
        "noCompleteTip":"Lamentamos, a informação introduzida está incorrecta e a operação acima foi mal-sucedida",
        "emailAndDocInvalid":"Este Endereço de E-mail já foi usado",
        "phoneAndDocInvalid":"Este Número de Telefone já foi usado",
        "IBCodeInvalid":"Código de Referência Incorrecto",
        "invalidBankCardNo":"O número do cartão bancário está incorrecto. Por favor, verifique-o antes de enviá-lo",
        "beneficiaryName":"Por favor, use o Nome da Conta deixado no Banco, terceiros não são permitidos",
        "employerName":"Não contactaremos o seu empregador",
        "errors":"Erros de rede",
        "unSelect":"Por favor selecione",
        "selectEmpStatusTip":"A sua situação profissional mostra que você é Aposentado/Estudante/Desempregado. O Mercado Cambial (Forex) e os Contratos por Diferença (CFDs) são altamente especulativos e acarretam um nível elevado de risco para o seu capital.</div><div style='padding-top:10px;'>Para proteger os seus interesses imediatos, nós vamos rever a sua aptidão para os produtos que oferecemos, com base aos documentos de suporte que facultar, confirmando o saldo das poupanças/heranças mencionado no seu pedido.</div>"
    },
    "ModalMsg":{
        "showModal":{
            "content":"Com base a informação fornecida no seu requerimento de conta da AT Global Markets Limited (UK) Limited, é necessário lhe informar que operações de CFDs e forex alavancado podem não ser adequadas para você. O trading alavancado acarreta um elevado grau de risco para o seu capital. A Empresa oferece um serviço somente de execução aos clientes, o que significa que você deve contar com suas capacidades e julgamento quando operar esses mercados. <br/><br/><b>Por favor, note: A AT Global Markets (UK) Limited oferece contas demo nas quais poderá praticar o trading com preços reais de mercado e a Empresa o encoraja a tentar isto antes de operar com dinheiro real.</b><br/><br/>Se ainda desejar abrir uma conta na AT Global Markets (UK) Limited, por favor, confirme aceitando a declaração abaixo.",
            "checkboxTxt":"Entendo que o trading de CFDs e trading com forex alavancado acarreta um elevado grau de risco para o meu capital. Eu consigo avaliar os riscos envolvidos e pretendo continuar o meu pedido para abrir uma conta.",
            "errorsTxt":"Por favor, marque a caixa",
            "btn":"Confirme"
        },
        "showAlert":{
            "title":"gorjeta:",
            "submitBtnTxt":"confirme",
            "cancleBtnTxt":"cancelar",
            "confirmBtnTxt":"confirme"
        }
    },
    "ratesModalMsg":{
        "p3_1":"ALERTA - MUDANÇAS DE NÍVEL DE MARGEM PARA TODOS OS TRADERS NO VAREJO",
        "p3_2":"Caro candidato,",
        "p3_2_1":"",
        "p3_3":"Por favor, note que devido as mudanças impostas pela Autoridade Europeia dos Valores Mobiliários (ESMA) que afetam Operadores do Varejo, todos os novos clientes ATFX, a partir de 2 de Julho, usarão as novos Níveis de Margem.",
        "p3_4":"As mudanças incluem um limite máximo de alavancagem que poderá ser oferecido aos traders de varejo",
        "p4_1":"Principais FX: Os pares de moedas que contenham dois dos seguintes: USD, EUR, JPY, GBP, CAD, CHF - 3.33% (Alavancagem 30:1)",
        "p4_2":"Menor FX:  Todos os outros pares de moedas - 5% (Alavancagem 20:1)",
        "p4_3":"Principais índices: UK100, FRA40, ESP35, US30, SPX500, NAS100, JP225, AUS200 5% (Alavancagem 20:1)",
        "p4_4":"Ouro: 5% (Alavancagem 20:1)",
        "p4_5":"Matérias-primas: 10% (Alavancagem 10:1)",
        "p5_1":"Protecção contra saldo negativo",
        "p5_2":"A ESMA introduziu uma nova regra para garantir que todos os Traders no Varejo nunca possam perder mais do que o dinheiro disponível na sua conta. Se o seu saldo for negativo, então a ATFX será obrigada a trazer o seu saldo de volta ao zero – sem nenhum custo para o cliente.",
        "p5_3":"Regra de fecho da margem de 50%.",
        "p5_4":"A ATFX já oferece a regra de Fecho de Margem de 50% para todos os clientes.",
        "p5_5":"Se desejar finalizar o seu requerimento e abrir uma Conta ATFX no Varejo, por favor, assinale abaixo",
        "p5_6":"Reconheço e concordo com as novas condições para Clientes do Varejo",
        "p6_2":"Por Favor, Concorde ",
        "btnText":"ENVIAR"
    },
    "verifyMsg": {
        "phone_exist": "Este número de telefone já foi utilizado, use um número de telefone alternativo.",
        "email_exist": "Este endereço de e-mail já foi utilizado, use um e-mail alternativo",
        "phoneAndemail_exist": "O número de telefone e o endereço de e-mail já foram utilizados, use um número de telefone e um e-mail alternativos.",
    }
}



// WEBPACK FOOTER //
// ./src/lang/pt.js